import * as cellModule from './SchoolSitesCell'
import { useCell } from 'src/lib/cellWrapper'

export default (props) => useCell(cellModule, props)
